import React from 'react';

const desktopLogoUrl = 'https://media-manager-c.questera.ai/greta-media/b00cad02cfeb55a1b54773f1814a28783966fac1191f97d55bc1db6658c27e2897de2ada8340abcbb890f1cad119b01d/images/aW1hZ2UvcG5n/38eb9ba65028c38fb5619656a6dce96b.png';
const mobileLogoUrl = 'https://media-manager-c.questera.ai/greta-media/b00cad02cfeb55a1b54773f1814a28783966fac1191f97d55bc1db6658c27e2897de2ada8340abcbb890f1cad119b01d/images/aW1hZ2UvcG5n/518dd9c5e0e4127674c1b779412ee90c.png';

function Brand({ compact = false }) {
  return (
    <>
      <style>{`
        :root {--ink: #08232a;--deep: #041b22;--paper: #f1fbfc;--white: #ffffff;--lime: #f7cf3d;--mint: #a8edf0;--purple: #b7e7ee;--yellow: #f7cf3d;--muted: #597178;--line: rgba(8,35,42,0.13);}
        h1 em,h2 em {color: #00aab7;}
        .sidebar-card,.service-grid article {background: #082b34;}
        .nav-item i {background: #f7cf3d;}
        .sidebar-card button,.primary-button:hover,.dark-button:hover {background: #00aab7;color: #ffffff;}
        .hero-visual {background: radial-gradient(circle at 70% 20%,rgba(247,207,61,0.52),transparent 27%),linear-gradient(145deg,#d5f6f5,#82cfd4);}
        .capacity-track span {background: #00aab7;}
        .services-section h2 em {color: #f7cf3d;}
        .service-grid article.featured {background: #00aab7;color: #ffffff;}
        .featured p {color: #d7ffff;}
        .audience-icon {background: #d8f7f7;color: #008d9b;}
        .quote-card {background: #f7cf3d;}
        .quote-person span {color: #635315;}
        .live-pill i {background: #00aab7;box-shadow: 0 0 0 3px rgba(0,170,183,0.17);}
        .mobile-dock button.active {color: #f7cf3d;}
        .mobile-dock button > span {background: rgba(247,207,61,0.13);}
        .brand {display: inline-flex;height: auto;max-width: ${compact ? '46px' : '184px'};}
        .brand-logo {display: block;height: auto;max-height: ${compact ? '42px' : '68px'};object-fit: contain;object-position: left center;width: 100%;}
        .brand-logo-mobile {display: none;}
        .mobile-header .brand {max-width: 137px;}
        .mobile-header .brand-logo {max-height: 48px;}
        @media (max-width: 1050px) and (min-width: 761px) {
          .brand {max-width: 163px;}
        }
        @media (max-width: 760px) {
          .mobile-header .brand-logo-desktop {display: none;}
          .mobile-header .brand-logo-mobile {display: block;}
        }
      `}</style>
      <a
        className={`brand ${compact ? 'brand-compact' : ''}`}
        href="#home"
        aria-label="Growth Sparrow home"
      >
        <img className="brand-logo brand-logo-desktop" src={desktopLogoUrl} alt="Growth Sparrow" />
        <img className="brand-logo brand-logo-mobile" src={mobileLogoUrl} alt="Growth Sparrow" />
      </a>
    </>
  );
}

export default Brand;